import * as React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import isEqual from 'react-fast-compare';
import styled, { css } from 'styled-components';

type Props = {
    children: React.ReactNode;
    className?: string;
    maxHeight: number;
    showScrollBar: boolean;
};

const ScrollBar = ({ children, className = '', maxHeight = 600, showScrollBar = true }: Props) => (
    <Scrollbars
        autoHeight
        autoHeightMax={maxHeight}
        hideTracksWhenNotNeeded
        renderThumbVertical={(props) => (
            <StyledThumbnailVertical
                $showScrollBar={showScrollBar}
                {...props}
            />
        )}
        renderTrackVertical={(props) => (
            <StyledTrackVertical
                $showScrollBar={showScrollBar}
                {...props}
            />
        )}
        renderView={(props) => (
            <div
                {...props}
                className={className}
            />
        )}
        universal
    >
        {children}
    </Scrollbars>
);

export default React.memo(ScrollBar, isEqual);

const StyledThumbnailVertical = styled.div<{ $showScrollbar: boolean }>`
    ${({ $showScrollbar }) =>
        $showScrollbar
            ? css`
                  width: 8px !important;
                  border-radius: 6px;
                  background: ${({ theme }) => theme.colors.blue200} !important;

                  &::-webkit-scrollbar-track-piece {
                      width: 6px;
                      border-radius: 6px;
                      background: ${({ theme }) => theme.colors.blue200} !important;
                  }
              `
            : css`
                  width: 0;
                  background: ${({ theme }) => theme.colors.white} !important;
              `}
`;

const StyledTrackVertical = styled.div<{ $showScrollbar: boolean }>`
    ${({ $showScrollbar }) =>
        $showScrollbar
            ? css`
                  border-radius: 3px;
                  background-color: ${({ theme }) => theme.colors.grey500};
                  opacity: inherit;
                  box-shadow: inset 0 1px 3px 0 ${({ theme }) => theme.colors.shadow200};
                  position: absolute;
                  width: 8px !important;
                  right: 2px;
                  bottom: 2px;
                  top: 2px;

                  &::-webkit-scrollbar-track {
                      border-radius: 6px;
                      background-color: ${({ theme }) => theme.colors.grey500};
                      opacity: inherit;
                      box-shadow: inset 0 1px 3px 0 ${({ theme }) => theme.colors.blue200};
                      position: absolute;
                  }
              `
            : css`
                  background-color: ${({ theme }) => theme.colors.white};
                  position: absolute;
                  width: 0;
                  right: 0;
                  bottom: 0;
                  top: 0;
              `}
`;
